// Loads as a plain classic <script> (no type="module"), placed first in
// <head>, so it can flag <html> before <body> even parses on a repeat visit
// this session — see snippets/loading-overlay.liquid for how that class
// suppresses the overlay's `open` markup with zero flash.
(function () {
  'use strict';

  var STORAGE_KEY = 'dozori:loading-overlay-shown';
  var SEEN_CLASS = 'loading-overlay-seen';
  var MIN_VISIBLE_MS = 400;

  var alreadySeen;
  try {
    alreadySeen = sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (err) {
    // sessionStorage can throw in some privacy modes. If we can't read it we
    // can't reliably write it either, so failing toward "already seen" (skip
    // the splash) avoids the exact bug this behavior replaces: showing on
    // every single load because the "seen" flag can never stick.
    alreadySeen = true;
  }

  if (alreadySeen) {
    document.documentElement.classList.add(SEEN_CLASS);
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var dialogEl = /** @type {HTMLDialogElement | null} */ (document.getElementById('loading-overlay'));

    setTimeout(function () {
      if (dialogEl && dialogEl.open) dialogEl.close();
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (err) {
        // Can't persist the flag — the splash will just show again on the
        // next load instead of staying hidden. Not ideal, but not harmful.
      }
    }, MIN_VISIBLE_MS);
  });
})();
